import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import React from "react";
import { formatDataRateSmart } from "kontrolEdge/helpers/formatDataRate";
interface PortCapacityChartProps {
  data: Array<{ name: string; value: number }>;
  isBreakdown?: boolean;
  totalCapacityGbps: number;
  centerValueMbps?: number;
  isViewingAll?: boolean;
  dataUnit?: "Gbps" | "Mbps";
}

export function PortCapacityChart({ data, isBreakdown = false, isViewingAll, centerValueMbps, dataUnit = "Gbps", }: PortCapacityChartProps) {
  // Fallbacks only if we DON'T pass centerValueMbps
  const toMbps = (v: number) => (dataUnit === "Gbps" ? v * 1000 : v);

  // Sum of all slices in Mbps (used in breakdown view)
  const sumAllMbps = data.reduce((sum, s) => sum + toMbps(Number(s.value) || 0), 0);

  // In single-customer view, exclude "Available" from the sum
  const tenantAllocatedMbps = data
    .filter(s => s.name.toLowerCase() !== "available")
    .reduce((sum, s) => sum + toMbps(Number(s.value) || 0), 0);

  // Decide the center value:
  // - Breakdown (all customers): show total allocated across customers (sumAll)
  // - Single customer: show only tenant allocated (tenantAllocated)
  const centerMbps =
    typeof centerValueMbps === "number"
      ? centerValueMbps
      : isBreakdown
        ? sumAllMbps
        : tenantAllocatedMbps;

  // const totalAllocatedGbps = data.reduce((sum, s) => sum + s.value, 0);

  const COLORS = ["#E5E7EB","#005E69", "#00BCD1", "#FAAEB0", "#761E21", "#3b82f6"];

  // Only skip grey when we're in "all customers"
  const shift = isViewingAll ? 1 : 0;
  return (
    <div style={{ height: '200px' }} className="relative">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            startAngle={180}
            endAngle={-180}
            innerRadius="70%"
            outerRadius="90%"
            paddingAngle={0}
            dataKey="value"
            strokeWidth={0}
          >
            {data.map((entry, i) => (
              <Cell key={entry.name} fill={COLORS[(i + shift) % COLORS.length]} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
        <span className="text-gray-500 text-sm">Total</span>
        <span className="text-lg font-semibold">
          {formatDataRateSmart(centerMbps)}
        </span>
      </div>
    </div>
  )
}

